import { FeatureTooltipItem } from '@/entities/pricing';

import SRTDownloadImg from '@/shared/assets/images/pricing/featureTooltips/srt-download.jpg';
import TeamspacesImg from '@/shared/assets/images/pricing/featureTooltips/teamspaces.jpg';
import UserPromptingImg from '@/shared/assets/images/pricing/featureTooltips/translation-prompting.png';
import { SRT_DOWNLOAD_DOC_LINK, TEAMSPACES_DOC_LINK, USER_PROMPT_FAQ_LINK } from '@/shared/constants/docLinks';
import { BoosterType } from '@/shared/types/Billing';

export const BOOSTER_TOOLTIP_MAP: Record<BoosterType, FeatureTooltipItem> = {
  [BoosterType.SRT]: {
    title: 'Download subtitles with original and translated text, or upload your own to sync with dubbing.',
    image: SRTDownloadImg,
    link: SRT_DOWNLOAD_DOC_LINK,
  },
  [BoosterType.TeamspaceSeat]: {
    title: 'Collaborate with your team with Teamspaces feature.',
    image: TeamspacesImg,
    link: TEAMSPACES_DOC_LINK,
  },
  [BoosterType.TranslationPrompting]: {
    description:
      'Set the tone, style, and context for translations using prompts. Use our templates or create your own to match your specific needs.',
    image: UserPromptingImg,
    link: USER_PROMPT_FAQ_LINK,
  },
};
